import React from 'react';
import { exportToCSV } from '../../utils/dashboardSharedUtils';

export default function EmployeeImportExport({ employees, t }) {
  const handleExportToCSV = () => {
    if (!employees || !employees.length) {
      alert(t('No employees to export'));
      return;
    }

    const headers = [
      'Name',
      'Department',
      'Role',
      'Contact',
      'Last Session',
      'Emotion Score',
      'Motivation Score',
      'Burnout Risk',
      'Stress Score',
      'Engagement Score'
    ];

    const rows = employees.map(e => [
      e.name || '',
      e.department || '',
      e.role || '',
      e.contact || '',
      e.last_session || '',
      e.emotionScore ?? '',
      e.motivationScore ?? '',
      e.finalRiskScore ?? '',
      e.stressScore ?? '',
      e.engagementScore ?? ''
    ]);

    exportToCSV(headers, rows, 'employees_export');
  };

  return (
    <button
      className="download-btn"
      onClick={handleExportToCSV}
      title={t('Export all employees to CSV')}
    >
      📥 {t('Export')}
    </button>
  );
}
